import { Component, Input } from '@angular/core';
import { productDisplayName } from '@kservice';

@Component({
  selector: 'kp-eligibility-error',
  templateUrl: './eligibility-error.component.html',
  styleUrls: ['./eligibility-error.component.scss'],
})
export class EligibilityErrorComponent {
  @Input() showGenericError = true;
  productName = productDisplayName;
}
